module.exports = __webpack_public_path__ + "img/exceedTime-logo.bedbc3aa.png";